// NavigationHandler.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "navigation/navigate"; // path to your utility

export const NavigationHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null; // This component only sets the navigate function
};
